// extracted by mini-css-extract-plugin
module.exports = {"content":"content-143uUx11 clearfix"};